import { gql } from '@apollo/client';

export const EXPORT_WORK_TIME_REPORT = gql`
  mutation ExportWorkTimeReport($startDate: DateTime!, $endDate: DateTime!, $employeeId: String, $applyTolerances: Boolean, $department: String, $departments: [String!], $employeeIds: [String!]) {
    exportWorkTimeReportToExcel(startDate: $startDate, endDate: $endDate, employeeId: $employeeId, applyTolerances: $applyTolerances, department: $department, departments: $departments, employeeIds: $employeeIds)
  }
`;

export const EXPORT_DAILY_WORK_REPORT = gql`
  mutation ExportDailyWorkReport($startDate: DateTime!, $endDate: DateTime!, $employeeId: String, $applyTolerances: Boolean, $department: String, $departments: [String!], $employeeIds: [String!]) {
    exportDailyWorkReportToExcel(startDate: $startDate, endDate: $endDate, employeeId: $employeeId, applyTolerances: $applyTolerances, department: $department, departments: $departments, employeeIds: $employeeIds)
  }
`;

export const EXPORT_SHIFT_REPORT = gql`
  mutation ExportShiftReport($startDate: DateTime!, $endDate: DateTime!, $employeeId: String, $applyTolerances: Boolean, $department: String, $departments: [String!], $employeeIds: [String!]) {
    exportShiftReportToExcel(startDate: $startDate, endDate: $endDate, employeeId: $employeeId, applyTolerances: $applyTolerances, department: $department, departments: $departments, employeeIds: $employeeIds)
  }
`;

export const CREATE_SHIFT = gql`
  mutation CreateShift($data: CreateShiftInput!) {
    createShift(data: $data) {
      id
      name
      description
      isDefault
      isActive
      lateArrivalToleranceMinutes
      earlyDepartureToleranceMinutes
      earlyArrivalToleranceMinutes
      lateDepartureToleranceMinutes
      employeeCount
      shiftTimes {
        id
        startTime
        endTime
        daysOfWeek
        order
        autoBreak
        autoBreakStartTime
        autoBreakEndTime
      }
    }
  }
`;

export const UPDATE_SHIFT = gql`
  mutation UpdateShift($id: String!, $data: UpdateShiftInput!) {
    updateShift(id: $id, data: $data) {
      id
      name
      description
      isDefault
      isActive
      lateArrivalToleranceMinutes
      earlyDepartureToleranceMinutes
      earlyArrivalToleranceMinutes
      lateDepartureToleranceMinutes
      employeeCount
      shiftTimes {
        id
        startTime
        endTime
        daysOfWeek
        order
        autoBreak
        autoBreakStartTime
        autoBreakEndTime
      }
    }
  }
`;

export const DELETE_SHIFT = gql`
  mutation DeleteShift($id: String!) {
    deleteShift(id: $id) {
      id
      name
    }
  }
`;